import { useLocalSearchParams } from 'expo-router'

import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionPrayScreen } from '@/src/features/intention/ui/screens/IntentionPrayScreen'
import { routeToPath, type TIntentionsPraySearchParams } from '@/src/general/constants/routes'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

const IntentionsPrayRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const {
    idSharetoken,
    source = TRACKING_SOURCE.UNDEFINED,
    theme,
  } = filterSearchParams<{ idSharetoken: TIdDashSlug } & TIntentionsPraySearchParams>(searchParams)

  const [intentionId, shareToken] = idSharetoken ? parseIdDash(idSharetoken) : [0, '']

  const { routes } = useRoutes()
  const fallbackRoute =
    source === TRACKING_SOURCE.INTENTION_PAGE ? routes.intentionById(intentionId, shareToken) : routes.intentions(theme)
  const { handleBackPress } = useBackHandlePress(fallbackRoute)

  return (
    <IntentionPrayScreen
      type={INTENTION_TYPE.INTENTION}
      intentionId={intentionId}
      shareToken={shareToken}
      source={source}
      theme={theme}
      redirect={routeToPath(fallbackRoute)}
      onClose={handleBackPress}
    />
  )
}

export default IntentionsPrayRouterPage
